module.exports = __webpack_public_path__ + "img/c05_unitbalearicslinger_Normal_ua.2f0e47da.webp";